<template>
    <div>
        <div class="container" v-if="additional_fields">
            <b-breadcrumb :items="breadcrumb" v-if="breadcrumb"></b-breadcrumb>

            <div class="row">
                <div class="d-none d-xl-block col-xl-3">
                    <catalog-categories></catalog-categories>
                </div>


                <div class="col-xl-9">

                    <div class="box-shadow p-0 mb-40">
                        <div>
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2247.540159197142!2d37.688083730647506!3d55.71436442530741!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x414ab4d7d083fbb5%3A0x8d30dbc3e7171fe1!2z0KPQs9GA0LXRiNGB0LrQsNGPINGD0LsuLCAy0JHRgTEsINCc0L7RgdC60LLQsCwg0KDQvtGB0YHQuNGPLCAxMTUwODg!5e0!3m2!1sru!2sde!4v1742813858204!5m2!1sru!2sde"
                                width="100%" height="300" style="border:0;" allowfullscreen="allowfullscreen" loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>

                        <div class="p-3">
                            <h1 class="as-h2 mb-24">Контакты</h1>

                            <div class="mb-24" v-if="additional_fields.contacts_address">
                                <span class="title-4">Мы находимся по адресу:</span>
                                <div v-html="additional_fields.contacts_address"></div>
                            </div>

                            <div class="mb-24" v-if="additional_fields.contacts_time">
                                <span class="title-4">Время работы:</span>
                                <div v-html="additional_fields.contacts_time"></div>
                            </div>

                            <div v-html="additional_fields.contacts_description"></div>

                        </div>

                    </div>

                    <div class="box-shadow p-0 mb-40">
                        <div class="box-shadow--title">
                            Как с нами связаться?
                        </div>
                        <div class="p-4 d-flex flex-column flex-lg-row justify-content-around">
                            <div class="text-center mb-4 mb-lg-0"
                                 v-if="additional_fields.contacts_phone_life || additional_fields.contacts_phone_mts">
                                <img src="/svg/contacts_phone.svg" alt="" class="mb-12">
                                <span class="h5">ТЕЛЕФОНЫ:</span>
                                <div class="mb-2" v-if="additional_fields.contacts_phone_mts"><a
                                    :href="'tel:' + additional_fields.contacts_phone_mts"
                                    class="hover-primary">{{ additional_fields.contacts_phone_mts }}</a>
                                </div>
                                <div v-if="additional_fields.contacts_phone_life"><a id="375_25_7777_585"
                                                                                     :href="'tel:' + additional_fields.contacts_phone_life"
                                                                                     class="hover-primary">{{ additional_fields.contacts_phone_life }}</a>
                                    (Life)
                                </div>
                            </div>

                            <div class="text-center mb-4 mb-lg-0"
                                 v-if="additional_fields.contacts_telegram || additional_fields.contacts_viber">
                                <img src="/svg/contacts_mess.svg" alt="" class="mb-12">
                                <span class="h5">МЕССЕНДЖЕРЫ:</span>
                                <div class="mb-2" v-if="additional_fields.contacts_telegram"><a
                                    :href="additional_fields.contacts_telegram" target="_blank" class="hover-primary">Telegram</a>
                                </div>
                                <div :class="additional_fields.contacts_whatsapp ? 'mb-2' : ''" v-if="additional_fields.contacts_viber"><a id="viber" target="_blank"
                                                                                :href="additional_fields.contacts_viber"
                                                                                class="hover-primary">Viber</a></div>
                                <div v-if="additional_fields.contacts_whatsapp"><a id="whatsapp" target="_blank"
                                                                                :href="additional_fields.contacts_whatsapp"
                                                                                class="hover-primary">Whatsapp</a></div>
                            </div>

                            <div class="text-center mb-4 mb-lg-0" v-if="additional_fields.contacts_email">
                                <img src="/svg/contacts_email.svg" alt="" class="mb-12">
                                <span class="h5">EMAIL ДЛЯ ЗАКАЗА:</span>
                                <div><a id="email" :href="'mailto:' + additional_fields.contacts_email"
                                        class="hover-primary">{{ additional_fields.contacts_email }}</a></div>
                            </div>

                            <div class="text-center"
                                 v-if="additional_fields.contacts_email_corp || additional_fields.contacts_phone_corp">
                                <img src="/svg/contacts_doc.svg" alt="" class="mb-12">
                                <span class="h5">БУХГАЛТЕРИЯ:</span>
                                <div v-if="additional_fields.contacts_email_corp" class="mb-2"><a
                                    :href="'mailto:' + additional_fields.contacts_email_corp"
                                    class="hover-primary">{{ additional_fields.contacts_email_corp }}</a></div>
                                <div v-if="additional_fields.contacts_phone_corp"><a
                                    :href="'tel:' + additional_fields.contacts_phone_corp"
                                    class="hover-primary">{{ additional_fields.contacts_phone_corp }} </a></div>
                            </div>
                        </div>
                    </div>

                    <div class="box-shadow p-0 d-none">
                        <div class="box-shadow--title">
                            Написать нам
                        </div>
                        <div class="p-3 p-sm-4">
                            <feedback-form></feedback-form>
                        </div>
                    </div>

                    <div v-if="loading" class="loading-box">
                        <b-spinner></b-spinner>
                    </div>

                    <div class="mt-5" v-if="seo_text">
                        <p v-html="seo_text"></p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    data() {
        return {
            loading: true,

            additional_fields: null,

            breadcrumb: null,
            seo_text: null
        }
    },

    watch: {
        $route() {
            this.loading = true;
            this.init();
        },
    },

    mounted() {
        this.init()
    },

    methods: {
        init() {

            let url = '/api/contact';
            axios.get(url)
                .then(response => {
                    this.additional_fields = response.data.additional_fields;
                    this.getBreadcrumb();
                    this.loading = false;

                    let seoInfo = response.data.seoInfo
                    this.seo_text = response.data.seoInfo.seo_text

                    document.title = seoInfo?.seo_title ? seoInfo?.seo_title : 'Контакты Фотопроката "MRental". Адрес, телефон, email.';
                    let desc = seoInfo?.seo_desc ? seoInfo?.seo_desc : 'Вы можете забронировать необходимую технику по телефону +7 977 409 72 39, оставить заявку по комплекту оборудования на почте rental@photobuba.by или приехать к нам в офис и оставить заявку.';
                    document.querySelector('meta[name="description"]').setAttribute("content", desc);
                    document.querySelector('meta[name="twitter:description"]').setAttribute("content", desc);
                    document.querySelector('meta[property="og:description"]').setAttribute("content", desc);
                    document.querySelector('meta[name="twitter:text:description"]').setAttribute("content", desc);
                })
        },

        getBreadcrumb() {
            this.breadcrumb = [
                {
                    text: 'Главная',
                    to: {name: 'pages-index'}
                },
                {
                    text: "Контакты",
                    active: true
                }
            ]
        }
    }
}
</script>

